(function () {
  const media = document.querySelector('.mhx-product__media[data-main-media]');
  const slotA = media?.querySelector('[data-slot="a"]');
  const slotB = media?.querySelector('[data-slot="b"]');
  const thumbs = document.querySelectorAll('.mhx-product__thumb[data-thumbnail]');

  // === Preload full-size images so gallery swaps are instant ===
  if (thumbs.length > 0) {
    const preloadAll = () => {
      thumbs.forEach((btn) => {
        const full = btn.dataset.full;
        if (!full) return;
        const img = new Image();
        img.sizes = '(min-width: 750px) 55vw, 100vw';
        if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
        img.src = full;
      });
    };
    if (document.readyState === 'complete') {
      preloadAll();
    } else {
      window.addEventListener('load', preloadAll, { once: true });
    }
  }

  // === Thumbnail gallery cross-fade + overlay arrows ===
  if (slotA && slotB && thumbs.length > 0) {
    const thumbsArr = Array.from(thumbs);
    const prevBtn = document.querySelector('[data-nav="prev"]');
    const nextBtn = document.querySelector('[data-nav="next"]');
    let currentSlot = slotA;
    let nextSlot = slotB;
    let currentIndex = 0;

    const updateNavVisibility = () => {
      if (prevBtn) prevBtn.hidden = currentIndex === 0;
      if (nextBtn) nextBtn.hidden = currentIndex >= thumbsArr.length - 1;
    };

    // === Arrow tone adaptation ===
    // Sample the pixel luminance under each arrow and pick solid black or white.
    const toneCache = new Map();

    const sampleImage = (url) =>
      new Promise((resolve) => {
        if (toneCache.has(url)) {
          resolve(toneCache.get(url));
          return;
        }
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          try {
            const w = 100;
            const h = 100;
            const canvas = document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, w, h);
            const scale = Math.min(w / img.naturalWidth, h / img.naturalHeight);
            const dw = img.naturalWidth * scale;
            const dh = img.naturalHeight * scale;
            ctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
            const sampleRegion = (sx, sy) => {
              const region = ctx.getImageData(sx, sy, 30, 30).data;
              let total = 0;
              const px = region.length / 4;
              for (let i = 0; i < region.length; i += 4) {
                total += 0.2126 * region[i] + 0.7152 * region[i + 1] + 0.0722 * region[i + 2];
              }
              return total / px;
            };
            const midY = (h - 30) / 2;
            const bottomY = h - 30;
            const result = {
              leftMid: sampleRegion(0, midY),
              rightMid: sampleRegion(w - 30, midY),
              leftBottom: sampleRegion(0, bottomY),
              rightBottom: sampleRegion(w - 30, bottomY),
            };
            toneCache.set(url, result);
            resolve(result);
          } catch (err) {
            resolve({ leftMid: 255, rightMid: 255, leftBottom: 255, rightBottom: 255 });
          }
        };
        img.onerror = () => resolve({ leftMid: 255, rightMid: 255, leftBottom: 255, rightBottom: 255 });
        img.src = url;
      });

    const applyTone = (btn, luminance) => {
      if (!btn) return;
      btn.dataset.tone = luminance < 128 ? 'light' : 'dark';
    };

    const updateNavTone = () => {
      const url = currentSlot.currentSrc || currentSlot.src;
      if (!url) return;
      sampleImage(url).then((data) => {
        const stillCurrent = (currentSlot.currentSrc || currentSlot.src) === url;
        if (!stillCurrent) return;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        applyTone(prevBtn, isMobile ? data.leftBottom : data.leftMid);
        applyTone(nextBtn, isMobile ? data.rightBottom : data.rightMid);
      });
    };

    const swapToIndex = (index, options) => {
      if (index < 0 || index >= thumbsArr.length) return;
      const fade = !options || options.fade !== false;
      const btn = thumbsArr[index];
      const full = btn.dataset.full;
      const srcset = btn.dataset.srcset;
      const alt = btn.dataset.alt || '';
      const width = btn.dataset.width;
      const height = btn.dataset.height;
      if (!full) return;

      thumbsArr.forEach((t) => t.classList.remove('is-active'));
      btn.classList.add('is-active');
      // Center the active thumb inside the carousel without scrolling the page.
      const carousel = btn.closest('.mhx-product__thumbnails');
      if (carousel) {
        const carouselRect = carousel.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
        const target = carousel.scrollLeft + (btnRect.left - carouselRect.left) - (carouselRect.width / 2) + (btnRect.width / 2);
        carousel.scrollTo({ left: target, behavior: 'smooth' });
      }

      currentIndex = index;
      updateNavVisibility();

      // If already showing this image, skip swap.
      if (currentSlot.src === full) return;

      if (!fade) {
        // Direct swap on the currently visible slot — no cross-fade.
        if (srcset) currentSlot.srcset = srcset;
        currentSlot.sizes = '(min-width: 750px) 55vw, 100vw';
        if (alt) currentSlot.alt = alt;
        if (width) currentSlot.width = width;
        if (height) currentSlot.height = height;
        currentSlot.src = full;
        updateNavTone();
        return;
      }

      const activate = () => {
        nextSlot.classList.add('is-current');
        currentSlot.classList.remove('is-current');
        nextSlot.removeAttribute('aria-hidden');
        currentSlot.setAttribute('aria-hidden', 'true');
        currentSlot.alt = '';
        const swap = currentSlot;
        currentSlot = nextSlot;
        nextSlot = swap;
        updateNavTone();
      };

      if (srcset) nextSlot.srcset = srcset;
      nextSlot.sizes = '(min-width: 750px) 55vw, 100vw';
      if (alt) nextSlot.alt = alt;
      if (width) nextSlot.width = width;
      if (height) nextSlot.height = height;
      nextSlot.src = full;

      if (nextSlot.complete && nextSlot.naturalWidth > 0) {
        requestAnimationFrame(activate);
      } else {
        nextSlot.addEventListener('load', activate, { once: true });
      }
    };

    thumbsArr.forEach((btn, index) => {
      btn.addEventListener('click', () => swapToIndex(index));
    });

    if (prevBtn) prevBtn.addEventListener('click', () => swapToIndex(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => swapToIndex(currentIndex + 1));

    // Swipe navigation on the main media (mobile touch) — image follows finger.
    if (media && thumbsArr.length > 1) {
      let touchStartX = null;
      let touchStartY = null;
      let swiping = false;
      let mediaWidth = 0;
      let swipeTargetIndex = -1;

      const finalizeSlot = (slot) => {
        slot.style.transition = 'none';
        slot.style.transform = '';
        slot.classList.remove('is-swiping');
        void slot.offsetWidth;
        setTimeout(() => {
          slot.style.transition = '';
        }, 50);
      };

      media.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) {
          touchStartX = null;
          return;
        }
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        swiping = false;
        mediaWidth = media.offsetWidth;
      }, { passive: true });

      media.addEventListener('touchmove', (e) => {
        if (touchStartX === null) return;
        const x = e.touches[0].clientX;
        const y = e.touches[0].clientY;
        const dx = x - touchStartX;
        const dy = y - touchStartY;

        if (!swiping) {
          if (Math.abs(dx) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            // Vertical intent — let page scroll.
            touchStartX = null;
            return;
          }
          swipeTargetIndex = dx < 0 ? currentIndex + 1 : currentIndex - 1;
          if (swipeTargetIndex < 0 || swipeTargetIndex >= thumbsArr.length) {
            touchStartX = null;
            return;
          }
          const targetBtn = thumbsArr[swipeTargetIndex];
          if (targetBtn.dataset.srcset) nextSlot.srcset = targetBtn.dataset.srcset;
          nextSlot.sizes = '(min-width: 750px) 55vw, 100vw';
          nextSlot.alt = targetBtn.dataset.alt || '';
          if (targetBtn.dataset.width) nextSlot.width = targetBtn.dataset.width;
          if (targetBtn.dataset.height) nextSlot.height = targetBtn.dataset.height;
          nextSlot.src = targetBtn.dataset.full;

          currentSlot.style.transition = 'none';
          nextSlot.style.transition = 'none';
          currentSlot.classList.add('is-swiping');
          nextSlot.classList.add('is-swiping');

          // Preemptively hide the edge arrow if the target is at an edge.
          if (prevBtn) prevBtn.hidden = swipeTargetIndex === 0;
          if (nextBtn) nextBtn.hidden = swipeTargetIndex >= thumbsArr.length - 1;

          swiping = true;
        }

        e.preventDefault();
        const gap = 12;
        const nextStartOffset = dx < 0 ? mediaWidth + gap : -(mediaWidth + gap);
        currentSlot.style.transform = `translateX(${dx}px)`;
        nextSlot.style.transform = `translateX(${dx + nextStartOffset}px)`;
      }, { passive: false });

      const finishSwipe = (dx) => {
        const duration = 250;
        const gap = 12;
        const threshold = mediaWidth / 4;
        const shouldComplete = Math.abs(dx) > threshold;
        const outgoingOffset = dx < 0 ? -(mediaWidth + gap) : (mediaWidth + gap);

        currentSlot.style.transition = `transform ${duration}ms ease-out`;
        nextSlot.style.transition = `transform ${duration}ms ease-out`;

        if (shouldComplete) {
          currentSlot.style.transform = `translateX(${outgoingOffset}px)`;
          nextSlot.style.transform = 'translateX(0)';
          setTimeout(() => {
            // Promote next → current.
            currentSlot.classList.remove('is-current');
            nextSlot.classList.add('is-current');
            currentSlot.setAttribute('aria-hidden', 'true');
            currentSlot.alt = '';
            nextSlot.removeAttribute('aria-hidden');
            finalizeSlot(currentSlot);
            finalizeSlot(nextSlot);
            const temp = currentSlot;
            currentSlot = nextSlot;
            nextSlot = temp;

            currentIndex = swipeTargetIndex;
            thumbsArr.forEach((t) => t.classList.remove('is-active'));
            const activeThumb = thumbsArr[currentIndex];
            if (activeThumb) {
              activeThumb.classList.add('is-active');
              activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
            updateNavVisibility();
            updateNavTone();
          }, duration + 20);
        } else {
          currentSlot.style.transform = 'translateX(0)';
          nextSlot.style.transform = `translateX(${-outgoingOffset}px)`;
          setTimeout(() => {
            finalizeSlot(currentSlot);
            finalizeSlot(nextSlot);
            // Restore arrow visibility based on where we actually are.
            updateNavVisibility();
          }, duration + 20);
        }
      };

      media.addEventListener('touchend', (e) => {
        if (!swiping) {
          touchStartX = null;
          return;
        }
        const dx = e.changedTouches[0].clientX - touchStartX;
        swiping = false;
        touchStartX = null;
        finishSwipe(dx);
      });

      media.addEventListener('touchcancel', () => {
        if (!swiping) {
          touchStartX = null;
          return;
        }
        swiping = false;
        touchStartX = null;
        finishSwipe(0);
      });
    }

    updateNavVisibility();

    // Initial tone read for the first image.
    if (currentSlot.complete && currentSlot.naturalWidth > 0) {
      updateNavTone();
    } else {
      currentSlot.addEventListener('load', updateNavTone, { once: true });
    }
  }

  // === Explainer popover: close on outside click ===
  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-explainer][open]').forEach((details) => {
      if (!details.contains(e.target)) {
        details.open = false;
      }
    });
  });

  // === Time-limited countdown (upcoming → active) ===
  const containers = document.querySelectorAll('[data-countdown-container]');
  if (containers.length === 0) return;

  const formatRemaining = (secondsLeft) => {
    if (secondsLeft <= 0) return null;
    const minutes = Math.floor(secondsLeft / 60);
    if (minutes < 1) return 'less than 1 minute';
    if (secondsLeft < 3600) return `${minutes} minute${minutes === 1 ? '' : 's'}`;
    const days = Math.floor(secondsLeft / 86400);
    const remainderSecs = secondsLeft - days * 86400;
    const hours = Math.ceil(remainderSecs / 3600);
    if (days >= 1) {
      if (hours === 0) return days === 1 ? '24 hours' : `${days} days`;
      if (hours === 24) return `${days + 1} days`;
      return `${days === 1 ? '1 day' : `${days} days`} and ${hours === 1 ? '1 hour' : `${hours} hours`}`;
    }
    return `${hours} hour${hours === 1 ? '' : 's'}`;
  };

  const applyState = (state, upcomingSecs) => {
    document.querySelectorAll('[data-purchase-wrapper]').forEach((el) => {
      el.hidden = state !== 'active';
    });
    document.querySelectorAll('[data-purchase-wrapper] button[type="submit"]').forEach((btn) => {
      btn.disabled = state !== 'active';
    });
    document.querySelectorAll('[data-release-placeholder="upcoming"]').forEach((el) => {
      el.hidden = state !== 'upcoming';
    });
    document.querySelectorAll('[data-release-placeholder="closed"]').forEach((el) => {
      el.hidden = state !== 'closed';
    });
    document.querySelectorAll('[data-release-ships]').forEach((el) => {
      el.hidden = state !== 'active';
    });
    document.querySelectorAll('[data-release-released]').forEach((el) => {
      el.hidden = state !== 'closed';
    });
  };

  const update = () => {
    const nowSec = Math.floor(Date.now() / 1000);
    containers.forEach((container) => {
      const startsAt = parseInt(container.dataset.startsAt, 10) || 0;
      const endsAt = parseInt(container.dataset.endsAt, 10) || 0;
      const upcoming = container.querySelector('[data-status="upcoming"]');
      const active = container.querySelector('[data-status="active"]');
      const closed = container.querySelector('[data-status="closed"]');

      if (startsAt && nowSec < startsAt) {
        if (upcoming) upcoming.hidden = false;
        if (active) active.hidden = true;
        if (closed) closed.hidden = true;
        const target = upcoming?.querySelector('[data-countdown]');
        if (target) target.textContent = formatRemaining(startsAt - nowSec) || '…';
        applyState('upcoming', startsAt - nowSec);
      } else if (endsAt && nowSec < endsAt) {
        if (upcoming) upcoming.hidden = true;
        if (active) active.hidden = false;
        if (closed) closed.hidden = true;
        const target = active?.querySelector('[data-countdown]');
        if (target) target.textContent = formatRemaining(endsAt - nowSec) || '…';
        applyState('active');
      } else {
        if (upcoming) upcoming.hidden = true;
        if (active) active.hidden = true;
        if (closed) closed.hidden = false;
        applyState('closed');
      }
    });
  };

  update();
  setInterval(update, 30000);
})();
